"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateColor = void 0;
const Colors_1 = require("@jsonjoy.com/ui/lib/styles/color/Colors");
/** Generate a deterministic color from a string (e.g. peerId). */
const generateColor = (str, alpha) => new Colors_1.Colors().hash(str).setA(100 * (alpha ?? 1)) + '';
exports.generateColor = generateColor;
